import { render, staticRenderFns } from "./SurfaceZonificationInfo.vue?vue&type=template&id=1adc4515&scoped=true"
import script from "./SurfaceZonificationInfo.vue?vue&type=script&lang=ts"
export * from "./SurfaceZonificationInfo.vue?vue&type=script&lang=ts"
import style0 from "./SurfaceZonificationInfo.vue?vue&type=style&index=0&id=1adc4515&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1adc4515",
  null
  
)

export default component.exports